export default [
  {
    path: "/bookTerms",
    component: () => import('../components/index/book/bookTerms'),
    redirect: '/book/rule'
  },
  {
    path: "/book/doc/:id",
    component: () => import('../page/book/doc')
  },
  {
    path: "/book/pre",
    component: () => import('../page/book/pre'),
    redirect: '/book'
  },
  {
    path: "/book/dept",
    component: () => import('../page/book/dept')
  },  /**
   * 预约挂号-选择科室
   * @query.bookHosId
   * @query.bookSort
   */
  {path: '/book/select/dept', component: () => import('../page/book/select/dept')},
  {path: '/book/mdt/pre', component: () => import('../page/book/mdt/pre')},
  /**
   * MDT
   */
  {path: '/book/mdt', component: () => import('../page/book/mdt.vue')},
  {path: '/book/mdt/scheme', component: () => import('../page/book/mdt/scheme.vue')},
  /**
   * 预约挂号-搜索
   */
  {path: '/book/search', component: () => import('../page/book/search')},
  /**
   * 当天挂号
   */
  {
    path: '/book/today',
    component: () => import('../page/book/today')
  },
  /**
   * 预约挂号
   */
  {
    path: '/book/book',
    component: () => import('../page/book/book'),
    children: [{
      path: 'expert',
      component: () => import('../page/book/book/expert'),
    }, {
      path: 'date',
      component: () => import('../page/book/book/date'),
    }]
  },
  /**
   * 就诊信息确认
   */
  {
    path: '/book/confirm',
    meta: {keepAlive: false},
    component: () => import('../page/book/confirm')
  },
  /**
   * 就诊信息确认
   */
  {
    path: '/book/success',
    component: () => import('../page/book/success')
  },
  /**
   *
   */
  {
    path: '/book/pay',
    component: () => import('../page/book/pay')
  },
  // halo 当日挂号支付
  {
    path: '/book/pay2/:isFirst',
    component: () => import('../page/book/pay2')
  },
  {
    path: '/book/rule',
    component: () => import('../page/book/rule')
  },
  /**
   * 专科
   */
  {
    path: '/book/expert',
    component: () => import('../page/book/expert')
  }
]



// WEBPACK FOOTER //
// ./src/router/book.js